export const Title: React.FC = ({ children }) => {
  return (
    <h1 className="text-2.5xl max-w-4xl font-semibold text-center lg:text-5xl leading-10 lg:leading-14 ">
      { children }
    </h1>
  )
}
